import { globalFilesEntityId } from "@sp-crm/core";
import { Col, Row } from "components/shared/grid";
import React from "react";
import { Content, PageHeader, Stage } from "../layout";

import { FilesControl } from "./index";

export const StandaloneFiles: React.FC<unknown> = () => {
    return (
        <Row type="flex">
            <Col className="component-wrapper w-full">
                <Stage>
                    <PageHeader title="Our Files" />
                    <Content>
                        <FilesControl
                            includeSignwise={false}
                            entityId={globalFilesEntityId}
                            showSearch
                        />
                    </Content>
                </Stage>
            </Col>
        </Row>
    );
};
